
enum GltfTypes {
  
  ACCESSOR                = 'accessors'            ,
  ACCESSOR_SPARSE         = "sparse"               ,
  ACCESSOR_SPARSE_INDICES = "sparseIndices"        ,
  ACCESSOR_SPARSE_VALUES  = "sparseValues"         ,
  ANIMATION               = 'animations'           ,
  ANIMATION_SAMPLER       = 'animationSamplers'    ,
  ANIMATION_CHANNEL       = 'animationChannels'    ,
  ASSET                   = 'asset'                ,
  BUFFER                  = 'buffers'              ,
  BUFFERVIEW              = 'bufferViews'          ,
  CAMERA                  = 'cameras'              ,
  IMAGE                   = 'images'               ,
  MATERIAL                = 'materials'            ,
  MESH                    = 'meshes'               ,
  NODE                    = 'nodes'                ,
  NORMAL_TEXTURE_INFO     = 'normalTextureInfo'    ,
  OCCLUSION_TEXTURE_INFO  = 'occlusionTextureInfo' ,
  PRIMITIVE               = 'primitives'           ,
  SAMPLER                 = 'samplers'             ,
  SCENE                   = 'scenes'               ,
  SKIN                    = 'skins'                ,
  TEXTURE                 = 'textures'             ,
  TEXTURE_INFO            = 'textureInfo'          ,
  
}

export default GltfTypes